import { createRouter, createWebHashHistory } from "vue-router";

//Lazy Load Components in the () => import functions
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: [
    { path: "/", redirect: "/home" },
    {
      path: "/home",
      component: () => import("@/pages/UeberUnsView.vue"),
      meta: { title: "LumaBIT | Über Uns", cache: true },
    },
    {
      path: "/jobs",
      children: [
        {
          path: "",
          component: () => import("@/pages/JobsView.vue"),
          meta: { title: "LumaBIT | Jobs", cache: true },
        },
        {
          path: "werkstudent",
          component: () =>
            import("@/pages/subpages/JobChildren/WerkstudentView.vue"),
          meta: { title: "LumaBIT | Werkstudent", cache: true },
        },
        {
          path: "tester",
          component: () =>
            import("@/pages/subpages/JobChildren/TesterView.vue"),
          meta: { title: "LumaBIT | Software - Tester", cache: true },
        },
        {
          path: "projekt",
          component: () =>
            import("@/pages/subpages/JobChildren/ProjektView.vue"),
          meta: { title: "LumaBIT | IT - Projekt", cache: true },
        },
        {
          path: "initiativ",
          component: () =>
            import("@/pages/subpages/JobChildren/InitiativView.vue"),
          meta: { title: "LumaBIT | Initiativbewerbung", cache: true },
        },
        {
          path: "entwickler",
          component: () =>
            import("@/pages/subpages/JobChildren/EntwicklerView.vue"),
          meta: { title: "LumaBIT | Software - Engineer", cache: true },
        },
        {
          path: "analyst",
          component: () =>
            import("@/pages/subpages/JobChildren/BusinessAnalyst.vue"),
          meta: { title: "LumaBIT | Business Analyst", cache: true },
        },
      ],
    },
    {
      path: "/technologien",
      component: () => import("@/pages/TechnologienView.vue"),
      meta: { title: "LumaBIT | Technologien", cache: true },
    },
    {
      path: "/partner",
      component: () => import("@/pages/PartnerView.vue"),
      meta: { title: "LumaBIT | Partner", cache: true },
    },
    {
      path: "/contact",
      component: () => import("@/pages/KontaktView.vue"),
      meta: { title: "LumaBIT | Kontakt", cache: true },
    },
    {
      path: "/imprint",
      component: () => import("@/pages/ImpressumView.vue"),
      meta: { title: "LumaBIT | Impressum", cache: true },
    },
    {
      path: "/legal",
      component: () => import("@/pages/AGBView.vue"),
      meta: { title: "LumaBIT | AGB" },
    },
    {
      path: "/erstitage",
      component: () => import("@/erstitage/ErstitagePage.vue"),
      meta: { title: "LumaBIT | Erstitage" },
    },
    {
      path: "/:notFound(.*)",
      redirect: "/home",
      meta: { title: "Seite nicht gefunden" },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});
router.beforeEach((to) => {
  document.title = to.meta?.title ?? "LumaBIT GmbH";
});

export default router;
